import { isShowNews1 } from "@/utils/isShowNews1";
import { nanoid } from "nanoid";

interface GoogleAd2Props {
  type: string;
  [key: string]: any;
}
export default function GoogleAd2(props: GoogleAd2Props) {
  useAdBodyClass(props.type, props.dataPosition);
  if (!isShowNews1().validMain) {
    return;
  }
  const [refreshId, setRefreshId] = useState(nanoid(8));
  useEffect(() => {
    setRefreshId(nanoid(8));
  }, []);
  const { type, dataPosition, ...args } = props;
  const AdCpt: any = {
    ads: () => <Ads2 {...args} />,
    adx: () => <Adx2 key={refreshId} {...{ ...props }} />,
    anchor: () => <Anchor2 key={refreshId} {...{ ...props }} />,
  };
  return AdCpt?.[type]?.();
}
